import { cx } from '@mildang/styled-system/css';
import { fallbackPage } from '@mildang/styled-system/recipes';
import { type CSSProperties, type ReactNode } from 'react';

/*
 * FallbackPage 의 `children` 에 버튼을 여러 개 넣을 때 쓰는 행 레이아웃 헬퍼.
 * Figma 2버튼 행 스펙(gap 8·center·wrap)을 한 곳에 고정해 모든 에러 화면의 버튼 정렬을 일관되게 한다.
 *
 * 예)
 *   <FallbackPage type="authority">
 *     <FallbackPageActions>
 *       <ResponsiveButton variant="secondary" onClick={onBack}>이전 페이지로</ResponsiveButton>
 *       <ResponsiveButton variant="primary" asChild><a href={homeHref}>홈으로</a></ResponsiveButton>
 *     </FallbackPageActions>
 *   </FallbackPage>
 */
export interface FallbackPageActionsProps {
  /** 버튼(들). 보통 `ResponsiveButton` 1~2개. */
  children: ReactNode;
  /** 루트 요소에 추가되는 className. */
  className?: string;
  /** 루트 요소(<div>)에 병합되는 인라인 스타일. */
  style?: CSSProperties;
}

export function FallbackPageActions({ children, className, style }: FallbackPageActionsProps) {
  return (
    <div className={cx(fallbackPage().actions, className)} style={style}>
      {children}
    </div>
  );
}
